const navigationFooter = document.querySelector('.navigation--footer')
const navPointsFooter = navigationFooter.querySelectorAll('a')


const getFooterState = (item) => {
    const pathnames = location.pathname.split('/').slice(1)
    const pathKey = item.getAttribute('data-name')
    const isActive = pathnames.includes(pathKey)

    if(isActive) {
        item.parentElement.classList.add('current')
    }
}

navPointsFooter.forEach(item => {
    getFooterState(item);
})
